function inferFilenameFromUrl(url) {
  if (!url) {
    return null;
  }

  try {
    const parsedUrl = new URL(url, window.location.origin);
    const pathnameParts = parsedUrl.pathname.split("/").filter(Boolean);
    const filename = pathnameParts[pathnameParts.length - 1];

    return filename ? decodeURIComponent(filename) : null;
  } catch (error) {
    const pathname = url.split("?")[0];
    const pathnameParts = pathname.split("/").filter(Boolean);
    const filename = pathnameParts[pathnameParts.length - 1];

    return filename ? decodeURIComponent(filename) : null;
  }
}

export function buildFileUrl(url, filename = null, options = {}) {
  if (!url) {
    return null;
  }

  const resolvedFilename = filename || inferFilenameFromUrl(url);

  try {
    const parsedUrl = new URL(url, window.location.origin);

    if (resolvedFilename) {
      parsedUrl.searchParams.set("filename", resolvedFilename);
    }

    if (options.contentDisposition) {
      parsedUrl.searchParams.set(
        "contentDisposition",
        options.contentDisposition
      );
    }

    return parsedUrl.toString();
  } catch (error) {
    const searchParams = new URLSearchParams();

    if (resolvedFilename) {
      searchParams.set("filename", resolvedFilename);
    }

    if (options.contentDisposition) {
      searchParams.set("contentDisposition", options.contentDisposition);
    }

    const queryString = searchParams.toString();

    if (!queryString) {
      return url;
    }

    return `${url}${url.includes("?") ? "&" : "?"}${queryString}`;
  }
}
